/**
 * Central API Client
 * Handles all HTTP requests with error handling and interceptors
 */

/**
 * Generic API request handler
 * @param {string} url - Full API URL
 * @param {object} options - Fetch options (method, body, headers, etc.)
 * @returns {Promise} - Response data
 */
export const apiRequest = async (url, options = {}) => {
  const {
    method = 'GET',
    body = null,
    headers = {},
    ...restOptions
  } = options;

  const config = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    ...restOptions,
  };

  if (body && method !== 'GET') {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API Request Error:', error);
    throw error;
  }
};

/**
 * GET request
 */
export const get = async (url, options = {}) => {
  return apiRequest(url, { ...options, method: 'GET' });
};

/**
 * POST request
 */
export const post = async (url, body, options = {}) => {
  return apiRequest(url, { ...options, method: 'POST', body });
};

/**
 * PUT request
 */
export const put = async (url, body, options = {}) => {
  return apiRequest(url, { ...options, method: 'PUT', body });
};

/**
 * PATCH request
 */
export const patch = async (url, body, options = {}) => {
  return apiRequest(url, { ...options, method: 'PATCH', body });
};

/**
 * DELETE request
 */
export const del = async (url, options = {}) => {
  return apiRequest(url, { ...options, method: 'DELETE' });
};

